import React from "react";
import useBookingAccess from "@common/hooks/useBookingAccess";
import BookingList from "./BookingList";
import BookingListApp from "../BookingListApp";

const BookingListWrapper = () => {
  const { isAdminBooking } = useBookingAccess();

  return isAdminBooking ? <BookingList /> : <BookingListApp />;
};

export default BookingListWrapper;
